import React, { useState } from "react";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { styled } from "@mui/material";
import { CoreHeader } from "@tanstack/react-table";
import { DefaultRow } from "../../types";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { ColumnFilterOptions } from "./ColumnFilterOptions";

export interface FilterButtonProps<TRow> {
  column: CoreHeader<TRow, unknown>["column"];
}

export const ColumnFilterButton = <TRow extends DefaultRow>({
  column,
}: FilterButtonProps<TRow>) => {
  const isFiltered = column.getIsFiltered();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const onClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    event.stopPropagation();
    setAnchorEl(anchorEl ? null : event.currentTarget.parentElement);
  };

  return (
    <>
      <StyledFilterButton
        onClick={onClick}
        className={`table-column-filter-button

 ${isFiltered ? "table-column-filter-button-active" : ""}`}
      >
        <FilterAltOutlinedIcon />
      </StyledFilterButton>
      <ColumnFilterOptions
        column={column}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
      />
    </>
  );
};

export default ColumnFilterButton;

const StyledFilterButton = styled("div")(({ theme }) => ({
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  paddingLeft: "2px",
  height: "-webkit-fill-available",

  svg: {
    fontSize: "1rem",
    fill: theme.tokens.colors.gray[5],
  },
  "&.table-column-filter-button-active svg": {
    fill: theme.tokens.colors.blue[1],
  },
}));
